var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.402-71.24q-31.579 0-53.838-22.487-22.26-22.488-22.26-54.067t22.488-53.838q22.488-22.259 54.067-22.259t53.838 22.488q22.26 22.488 22.26 54.067 0 31.578-22.488 53.838-22.488 22.259-54.067 22.259Zm408.513 0q-31.679 0-53.819-22.487-22.139-22.488-22.139-54.067t22.423-53.838q22.423-22.259 53.911-22.259 31.799 0 53.939 22.488t22.14 54.067q0 31.578-22.388 53.838-22.387 22.259-54.067 22.259Zm-487.85-742.325h601.314q25.329 0 38.823 23.63 13.494 23.631.298 47.5L703.45-494.471q-11.311 20.175-30.675 33.247-19.365 13.072-42.851 13.072h-305.62l-50 92.956h494.457v74.435H270.63q-46.717 0-66.576-31.859-19.858-31.858.62-70.337l62-115.043-150.565-320.13h-81.24v-74.435h129.196l37 79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.5f0ff196dd0e33e4b1e0641e9b57a595.svg";
export { ForwardRef as ReactComponent };